export const interactiveTrpcRequestContext = {
  requestPriority: "interactive",
} as const;

export function isInteractiveTrpcRequest(
  context: Record<string, unknown> | undefined,
) {
  return context?.requestPriority === interactiveTrpcRequestContext.requestPriority;
}
